import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_309: DocMigration = {
  maxSchemaVersion: "0.0.309",
  description: "Fix scale of content template contents (this is basic as this feature is not generally supported yet)",
  apply(json: any): any {
    for (const annotationId in json.annotation) {
      const anno = json.annotation[annotationId];

      const parentId = anno.parentId;

      if (json.contentTemplates?.[parentId] === undefined) {
        continue;
      }

      switch (anno.type) {
        case "LINEWORK": {
          for (const shapeId in anno.shapes) {
            const shape = anno.shapes[shapeId];
            for (let i = 0; i < shape.path.length; i++) {
              shape.path[i] *= 1 / 72;
            }
          }
          break;
        }
        case "NOTE": {
          anno.x *= 1 / 72;
          anno.y *= 1 / 72;
          anno.textBoxWidth *= 1 / 72;
          anno.textBoxHeight *= 1 / 72;
          anno.fontSize *= 1 / 72;
          if (anno.landingLineX !== undefined) {
            anno.landingLineX *= 1 / 72;
          }
          if (anno.landingLineY !== undefined) {
            anno.landingLineY *= 1 / 72;
          }
          if (anno.leaderLineX !== undefined) {
            anno.leaderLineX *= 1 / 72;
          }
          if (anno.leaderLineY !== undefined) {
            anno.leaderLineY *= 1 / 72;
          }
          break;
        }
        case "LINEAR_DIMENSION": {
          anno.lineStartX *= 1 / 72;
          anno.lineStartY *= 1 / 72;
          anno.lineEndX *= 1 / 72;
          anno.lineEndY *= 1 / 72;
          anno.startX *= 1 / 72;
          anno.startY *= 1 / 72;
          anno.endX *= 1 / 72;
          anno.endY *= 1 / 72;
          break;
        }
      }
    }

    if (json.viewports) {
      for (const viewportId in json.viewports) {
        const viewport = json.viewports[viewportId];
        for (let i = 0; i < viewport.outline.length; i++) {
          viewport.outline[i] *= 1 / 72;
        }

        // best effort conversion (again, not generally supported yet)
        if (oldToNewViewportScales[viewport.scale]) {
          viewport.scale = oldToNewViewportScales[viewport.scale];
        } else {
          viewport.scale = 1 / 24;
        }

        // originally pan was in dpi in paper space, now it is in world coords
        viewport.panX = ((1 / viewport.scale) * viewport.panX) / 72;
        viewport.panY = ((1 / viewport.scale) * viewport.panY) / 72;
      }
    }

    return json;
  },
};

export default migration_0_0_309;

const oldToNewViewportScales = {
  [4 / 64]: 3 / 24,
  [8 / 64]: 1.5 / 24,
  [12 / 64]: 1 / 24,
  [16 / 64]: 3 / 4 / 24,
  [24 / 64]: 1 / 2 / 24,
  [32 / 64]: 3 / 8 / 24,
  [48 / 64]: 1 / 4 / 24,
  [64 / 64]: 3 / 16 / 24,
  [96 / 64]: 1 / 8 / 24,
  [128 / 64]: 3 / 32 / 24,
  [192 / 64]: 1 / 16 / 24,
};
